"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeparturePickerDesktop = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SearchSelect = require("../SearchSelect");
var _CustomOption = require("./components/CustomOption");
var _DropdownIndicator = require("./components/DropdownIndicator");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Components:

// Intefaces:

var customStyles = {
  menu: function menu() {
    return {
      width: 230,
      overflow: 'hidden'
    };
  },
  menuList: function menuList() {
    return {
      maxHeight: 489
    };
  }
};
var DeparturePickerDesktop = exports.DeparturePickerDesktop = function DeparturePickerDesktop(props) {
  var departure = props.departure,
    departuresList = props.departuresList,
    onChangeDeparture = props.onChangeDeparture,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  var handleChange = function handleChange(val) {
    return onChangeDeparture(val);
  };
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    input = _useState2[0],
    setInput = _useState2[1];
  var options = departuresList.filter(function (dep) {
    return dep.name_ru.toLocaleLowerCase().includes(input.toLocaleLowerCase());
  });
  if (!options.length) {
    options = (0, _toConsumableArray2["default"])(departuresList);
    options.unshift({
      id: -1,
      name_ru: 'Такой город не найден'
    });
  }
  var handleOpenMenu = function handleOpenMenu() {
    setTimeout(function () {
      var selectedEl = document.getElementsByClassName('departure-picker__selected-option')[0];
      if (selectedEl) {
        selectedEl.scrollIntoView({
          block: 'center'
        });
      }
    }, 15);
  };
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_SearchSelect.SearchSelect, {
    value: departure,
    defaultValue: departure,
    options: options,
    inputValue: input,
    onInputChange: setInput,
    onChange: handleChange,
    customStyles: customStyles,
    filterOption: function filterOption() {
      return true;
    },
    placeholder: "\u041E\u0442\u043A\u0443\u0434\u0430",
    noOptionsMessage: function noOptionsMessage() {
      return 'Нет таких городов вылета';
    },
    getOptionLabel: function getOptionLabel(option) {
      return option.name_ru;
    },
    getOptionValue: function getOptionValue(option) {
      return option.id;
    },
    onMenuOpen: handleOpenMenu,
    CustomOption: _CustomOption.CustomOption,
    CustomDropdownIndicator: _DropdownIndicator.DropdownIndicator,
    isSearchable: true
  }));
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeparturePickerdesktop__StyledWrapper",
  componentId: "sc-dhf3gr-0"
})(["position:relative;"]);